export default __webpack_public_path__ + "static/digital_marketing_service_banner-bc0452e5960ec81c9ce8c15e576e6f86.svg";